export default function ({ store, redirect, route }) {
  // if (!route.name.includes('management-company') && !(route.name === 'profile-tab') && !route.name.includes('documents') && store.getters['session/role'] === 'client' && !store.getters['session/hasCompany'] && !route.name.includes('tasks')) {
  //  return redirect('/management/company')
  // }
}
